import { Modal } from "antd";
import { Pen, Trash2Icon } from "lucide-react";
import React, { useState } from "react";
import Moment from "react-moment";
import { useRemoveEducation } from "../../../../hooks/api/Tutors/UpdateProfile/useRemoveEducation";
import UpdateEducationForm from "../../../Tutors/Profile/components/UpdateEducationForm";

type Props = {
  id?: string;
  degree: string;
  college: string;
  majors?: string;
  enrolled: string;
  graduated: string;
  educationCount: number;
};

const EducationCard = ({
  college,
  degree,
  majors,
  enrolled,
  graduated,
  id,
  educationCount,
}: Props) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const { mutate } = useRemoveEducation();

  return (
    <div className="mb-[30px]">
      <p className="text-primary900 mb-1 W2STMedium">{college}</p>
      <p className="text-gray700 mb-1">
        {degree} {majors && `in ${majors}`}
      </p>
      <div className="text-gray700">
        <Moment format="YYYY" date={enrolled} parse="YYYY" />
        {" - "}
        <Moment format="YYYY" date={graduated} parse="YYYY" />
      </div>

      <div className="mt-3 flex flex-row gap-6">
        <button
          onClick={() => setEditModalOpen(true)}
          className="flex gap-2 items-center text-green-700 text-[12px] cursor-pointer rounded-md"
        >
          <Pen size={15} />
          <span>Edit</span>
        </button>
        {educationCount > 1 && (
          <button
            onClick={() => setDeleteModalOpen(true)}
            className="flex gap-2 items-center text-red-700 text-[12px] cursor-pointer rounded-md"
          >
            <Trash2Icon size={15} />
            <span>Delete</span>
          </button>
        )}
      </div>

      <Modal
        width="400px"
        footer={null}
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        title={`Delete Education from ${college}`}
      >
        <p className="text-gray700">
          Confirm that you'd like to delete this educational qualification. Note
          that this process is irreversible
        </p>
        <div className="flex gap-2 mt-4">
          <button
            onClick={() => {
              mutate(id, {
                onSuccess: () => {
                  setDeleteModalOpen(false);
                },
              });
            }}
            className="p-3 rounded-md bg-red-600 text-white flex-1"
          >
            Yes
          </button>
          <button
            onClick={() => setDeleteModalOpen(false)}
            className="p-3 rounded-md bg-primary100 text-primary700 flex-1"
          >
            No
          </button>
        </div>
      </Modal>

      <Modal
        width="600px"
        footer={null}
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        title="Update Education"
      >
        {editModalOpen && (
          <UpdateEducationForm
            initialValues={{
              id: id || "",
              college,
              majors,
              degree,
              enrolled,
              graduated,
            }}
            onCancel={() => setEditModalOpen(false)}
          />
        )}
      </Modal>
    </div>
  );
};

export default EducationCard;
